import React, { Component } from 'react'
import { getBaseURI } from 'libraries/front-end-core/helpers/document'
import { replaceUrl } from 'libraries/front-end-core/core/history'

export default class LoginMain extends Component {
  get redirectUrl () {
    return getBaseURI() + this.props.redirectTo
  }

  render () {
    const { redirectTo } = this.props
    return (
      <div className=''>
        <h2 className=''>
          log in here
        </h2>
        <div>will redirect to {redirectTo} <button onClick={() => replaceUrl(this.redirectUrl)}>go</button></div>
      </div>
    )
  }
}
